import { useEffect, useMemo } from 'react';
import { getSortField, getSortValue, sortKey } from '../../../../features/table/helpers';
import { useLang } from '../../../../hooks/use-lang';
import { useQueryParams } from '../../../../hooks/use-query-params';
import { usePromotionStore } from '../../../../store/use-promotion-store';
import { SortType } from '../../../../types/props';
import { defaultViewStyle, viewStyleKey, withArchiveKey } from '../../../../helpers/path';
import { FetchPromoListRequest } from '../../../../store/api/promotion-api';

export const usePromoList = () => {
  const { fetchPromoList, restorePromo, deletePromo, list } = usePromotionStore();
  const { t } = useLang();

  const { getQueryParams } = useQueryParams();
  const params = getQueryParams();

  const name = params.name;
  const description = params.description;
  const status = params.status;
  const activeFrom = params.active_from;
  const activeTo = params.active_to;
  const sort = params[sortKey];
  const sortField = getSortField(sort);
  const sortDirection = getSortValue(sort) as SortType;
  const ts = params['ts'];
  const with_archive = !!params[withArchiveKey];
  const viewStyle = params[viewStyleKey] || defaultViewStyle;

  const requestParams: FetchPromoListRequest = useMemo(() => {
    return {
      name,
      description,
      status,
      active_from: activeFrom,
      active_to: activeTo,
      field: sortField,
      dir: sortDirection,
      since_id: 0,
      n: 1000,
      is_by_company: true,
      place_id: 0,
      with_archive,
    };
  }, [
    activeFrom,
    activeTo,
    description,
    name,
    sortDirection,
    sortField,
    status,
    ts,
    with_archive,
    viewStyle,
  ]);
  useEffect(() => {
    fetchPromoList(requestParams);
  }, [requestParams]);

  // const handleEnd = () => {
  //   if (isLoadingFetch || !pagination || pagination.is_last) return;
  //   const nextPage = pagination.page + 1;
  //   fetchPromoList({ ...requestParams, page: nextPage, infinite: true });
  // };

  return {
    t,
    restorePromo,
    deletePromo,
    viewStyle,
    list,
  };
};
